export const GET_ANDROID_BANNER_TOP_BANNER = 'GET_ANDROID_BANNER_TOP_BANNER';
export const GET_ANDROID_BANNER_TOP_BANNER_SUCCESS = 'GET_ANDROID_BANNER_TOP_BANNER_SUCCESS';

export const GET_ANDROID_RECOMMEND_SOFT = 'GET_ANDROID_RECOMMEND_SOFT';
export const GET_ANDROID_RECOMMEND_SOFT_SUCCESS = 'GET_ANDROID_RECOMMEND_SOFT_SUCCESS';

export const GET_ANDROID_RECOMMEND_GROUP_SOFT = 'GET_ANDROID_RECOMMEND_GROUP_SOFT';
export const GET_ANDROID_RECOMMEND_GROUP_SOFT_SUCCESS = 'GET_ANDROID_RECOMMEND_GROUP_SOFT_SUCCESS';

export const GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE = 'GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE';
export const GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE_SUCCESS = 'GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE_SUCCESS';
